<div style="max-width: 1700px; margin: 0 auto;">
  <div class="subtable-title mb-3" *ngIf="basicData && basicData.length">
    <div>
      <div>PERIODO</div>
      <div>{{report.reportDetails.periodRange}}</div>

    </div>
  </div>
  <div *ngIf="basicData && basicData.length">
    <div *ngFor="let report of basicData" class="report-container" style="margin-bottom: 2rem;">
      <!-- Nombre del reporte -->
      <h3 class="header-cell w-100">{{ report[0].name }}</h3>
  
      <!-- PrimeNG Table -->
      <p-table [value]="getRows(report)" [responsiveLayout]="'scroll'">
        <ng-template pTemplate="header">
          <tr>
            <th *ngFor="let col of getColumns(report)" class="header-cell">
              {{ col }}
            </th>
          </tr>
        </ng-template>
  
        <ng-template pTemplate="body" let-rowData>
          <tr>
            <td class="body-cell" *ngFor="let cell of rowData">{{ cell }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  
  <div *ngIf="!basicData || basicData.length === 0" class="no-data-container d-flex flex-column align-items-center justify-content-center">
    <i class="pi pi-info-circle" style="font-size: 2rem; margin-bottom: 0.5rem;"></i>
    <span>No hay datos disponibles</span>
  </div>
</div>